import React from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Problem } from './components/Problem';
import { Gallery } from './components/Gallery';
import { Solution } from './components/Solution';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showPurchaseNotifications?: boolean;
}
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  useMetaPixel();
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="23vuo6c6s2uum">
      <div className="w-full bg-white" data-id="element-1" data-mp="23utbk3a460as">
        <main data-id="element-2" data-mp="3ijxnsm94vshs">
          <Hero data-id="element-3" data-mp="3ikh8ubu2yx01" />
          <ProofBar data-id="element-4" data-mp="3iiwdijzxza14" />
          <Problem data-id="element-5" data-mp="3ijfw82xf22g7" />
          <Gallery data-id="element-6" data-mp="3ihv0i9zd8dgr" />
          <Solution data-id="element-7" data-mp="3mlj8uuvtnd32" />
          <WhatYouGet data-id="element-8" data-mp="3mkrd9k285fcs" />
          <Bonuses data-id="element-9" data-mp="3mk85gw6ag7ch" />
          <Pricing data-id="element-10" data-mp="3mjq45l4rr2xp" />
          <Testimonials data-id="element-11" data-mp="3mj6lu3b7icj5" />
          <Guarantee data-id="element-12" data-mp="3rbrbqtqzs5he" />
          <Faq data-id="element-13" data-mp="3rdki07xp0nov" />
        </main>
        <Footer data-id="element-14" data-mp="3recdzjv7cnfo" />
        {showPurchaseNotifications && <PurchaseToast data-id="element-15" data-mp="67znpl2q47d" />}
      </div>
    </MotionConfig>;
}